export const KEYCLOAK_URL =  process.env.REACT_APP_KEYCLOAK_URL || window.ENV?.REACT_APP_KEYCLOAK_URL;
export const KEYCLOAK_REALM = process.env.REACT_APP_KEYCLOAK_REAML || window.ENV?.REACT_APP_KEYCLOAK_REAML;
export const KEYCLOAK_CLIENT_ID =  process.env.REACT_APP_KEYCLOAK_CLIENT_ID || window.ENV?.REACT_APP_KEYCLOAK_CLIENT_ID;
export const API_URL = process.env.REACT_APP_API_URL || window.ENV?.REACT_APP_API_URL;
